import React from 'react'
import util from '../../../util/tools'
const jumpUrl = "https://m.weidaoip.com/youhe/book/content/"
export const goRoute = (props,bookId,contentId,payed) => {
    if(bookId >= 120000000 && bookId < 130000000){
        util.ajax({
            url: "/zh/additional/randomstr",
            isUser: true,
            isWechatId: true,
            method: "post",
            callback: res => {
                if (res.result.status.code == 0) {
                    let random_str = res.result.data.random_str;
                    let _promotion_data = localStorage.getItem('_promotion_data');
                    let { channel_id,promotions_id } = JSON.parse(_promotion_data)
                    let addPath = `${channel_id!==undefined ? "&channel_id="+channel_id : ""}&${promotions_id!==undefined ? "promotions_id="+promotions_id : ""}`
                    document.location.href = `https://m.weidaoip.com/youhe/book/content/${bookId}/${contentId}?source=${document.location.host}&user_token=${util.user_token}&random_str=${random_str}${addPath}`;
                }
            }
        });
        return false;
    }
    if(!!payed){
        props.history.push(`/readpage/${bookId}/${contentId}/1`)
    }else {
        props.history.push(`/readpage/${bookId}/${contentId}`)
    }
    return false;
    util.ajax({
        url: "/zh/user/getUserReadHistory",
        isUser: true,
        isWechatId: true,
        data: {
            page: 1,
            num: 1,
            book_id: bookId,
            order_by: "c_order DESC"
        },
        callback: res => {
            if (res.result.status.code == 0) {
                let json = res.result.data;
                let conId = contentId;
                if(json.length>0){
                    conId = json[0].content_id
                }
                if(!!payed){
                    props.history.push(`/readpage/${bookId}/${conId}/1`)
                }else {
                    props.history.push(`/readpage/${bookId}/${conId}`)
                }
            }
        }
    });
}